import React from 'react'
import './ErrorState.css'

interface ErrorStateProps {
  title: string
  message?: string
  action?: React.ReactNode
}

export const ErrorState: React.FC<ErrorStateProps> = ({ title, message, action }) => {
  return (
    <div className="errorState">
      <div className="errorState__icon">⚠️</div>
      <h3 className="errorState__title">{title}</h3>
      {message && <p className="errorState__message">{message}</p>}
      {action && <div className="errorState__action">{action}</div>}
    </div>
  )
}
